{
  "PID 与控制频率 · 物理AI实验室 Lab 1.2": {
    "en": "PID and control rate · Physical AI Lab 1.2",
    "ja": "PID と制御周波数 · Physical AI Lab 1.2"
  },
  "把一根倒立的杆撑住": {
    "en": "Balance an inverted pole",
    "ja": "逆さの棒を立たせておく"
  },
  "杆自己会倒。控制器默认每秒<span style=\"color:var(--see)\">看</span> 200 次角度，按 P、I、D <span style=\"color:var(--think)\">算出</span>该用多大的力，电机再把它<span style=\"color:var(--act)\">推回去</span>。": {
    "en": "It falls by itself. By default, 200 times a second the controller <span style=\"color:var(--see)\">reads</span> the angle, <span style=\"color:var(--think)\">computes</span> a force from P, I, D, and the motor <span style=\"color:var(--act)\">pushes it back</span>.",
    "ja": "棒は放っておくと倒れます。制御器は初期設定で毎秒 200 回、角度を<span style=\"color:var(--see)\">見て</span>、P・I・D で必要な力を<span style=\"color:var(--think)\">計算し</span>、モーターが棒を<span style=\"color:var(--act)\">押し戻します</span>。"
  },
  "看": {
    "en": "See",
    "ja": "見る"
  },
  "想": {
    "en": "Think",
    "ja": "考える"
  },
  "动": {
    "en": "Act",
    "ja": "動く"
  },
  "角度 200 Hz": {
    "en": "Angle 200 Hz",
    "ja": "角度 200 Hz"
  },
  "角度 {0} Hz": {
    "en": "Angle {0} Hz",
    "ja": "角度 {0} Hz"
  },
  "力矩 0": {
    "en": "Torque 0",
    "ja": "トルク 0"
  },
  "力矩 {0}": {
    "en": "Torque {0}",
    "ja": "トルク {0}"
  },
  "控制器 · controller": {
    "en": "Controller",
    "ja": "制御器 · controller"
  },
  "比例": {
    "en": "Prop.",
    "ja": "比例"
  },
  "积分": {
    "en": "Integral",
    "ja": "積分"
  },
  "微分": {
    "en": "Deriv.",
    "ja": "微分"
  },
  "控制频率": {
    "en": "Rate",
    "ja": "周波数"
  },
  "目标角": {
    "en": "Target",
    "ja": "目標角"
  },
  "角度": {
    "en": "Angle",
    "ja": "角度"
  },
  "误差": {
    "en": "Error",
    "ja": "誤差"
  },
  "力矩": {
    "en": "Torque",
    "ja": "トルク"
  },
  "周期": {
    "en": "Period",
    "ja": "周期"
  },
  "频率": {
    "en": "Rate",
    "ja": "周波数"
  },
  "推一下 ▸": {
    "en": "Push ▸",
    "ja": "押す ▸"
  },
  "扶起来 ↺": {
    "en": "Stand it up ↺",
    "ja": "立て直す ↺"
  },
  "角度 · angle over the last 8 s": {
    "en": "Angle over the last 8 s",
    "ja": "角度 · angle over the last 8 s"
  },
  "— 目标": {
    "en": "— target",
    "ja": "— 目標"
  },
  "— 实际": {
    "en": "— actual",
    "ja": "— 実際"
  },
  "θ* 目标": {
    "en": "θ* target",
    "ja": "θ* 目標"
  },
  "目标 θ*": {
    "en": "target θ*",
    "ja": "目標 θ*"
  },
  "误差 {0}°": {
    "en": "error {0}°",
    "ja": "誤差 {0}°"
  },
  "倒了：控制跟不上": {
    "en": "it fell: the control couldn't keep up",
    "ja": "倒れた：制御が追いつかない"
  },
  "来回震荡": {
    "en": "swinging back and forth",
    "ja": "行ったり来たり振動"
  },
  "稳住了，但老差 {0}°": {
    "en": "holds, but stays {0}° off",
    "ja": "止まったが、ずっと {0}° ずれている"
  },
  "稳在目标上": {
    "en": "holding on target",
    "ja": "目標で安定"
  },
  "拖滑块调控制器 · 拖动空白处旋转视角 · “推一下”看它能不能纠回来": {
    "en": "Drag the sliders to tune · drag empty space to orbit · \"Push\" to see if it recovers",
    "ja": "スライダーで制御器を調整 · 空いた所をドラッグして視点を回す · 「押す」で立ち直れるか試す"
  }
}
